(() => {
  if (window.adaptiveAnnouncementBarInitialized) return;
  window.adaptiveAnnouncementBarInitialized = true;

  const update = (bar) => {
    const slider = bar.querySelector('.announcement-bar-slider .slider');
    const messages = [...bar.querySelectorAll('.announcement-bar__message')];
    if (!slider || messages.length < 2) return;

    const availableWidth = Math.max(0, bar.getBoundingClientRect().width - 32);
    const contentWidth = messages.reduce((total, message) => {
      const text = message.querySelector('span');
      return total + Math.ceil(text?.getBoundingClientRect().width || message.scrollWidth);
    }, 0) + Math.max(0, messages.length - 1) * 32;
    const fits = contentWidth <= availableWidth;

    bar.classList.toggle('announcement-bar--content-fits', fits);
    bar.dataset.overflowState = fits ? 'fits' : 'overflow';
    bar.querySelectorAll('.slider-button').forEach((button) => { button.hidden = fits; });

    if (fits) {
      slider.setAttribute('aria-live', 'polite');
      bar.querySelectorAll('.slider__slide').forEach((slide) => {
        slide.setAttribute('aria-hidden', 'false');
        slide.removeAttribute('tabindex');
        slide.querySelectorAll('a').forEach((link) => link.removeAttribute('tabindex'));
      });
      if (typeof bar.pause === 'function') bar.pause();
    } else if (typeof bar.setSlideVisibility === 'function') {
      bar.setSlideVisibility();
    }
  };

  const normalizeEssentialBar = (bar) => {
    if (bar.dataset.inspireLayoutNormalized === 'true') return;
    const source = bar.querySelector('[class*="essential_annoucement_bar_running_line_title_"] span');
    const content = bar.querySelector('[class*="essential_annoucement_main_content_wrapper_"]');
    if (!source || !content) return;
    const messages = source.textContent.split(/\s*•{3}\s*/).map((message) => message.trim()).filter(Boolean);
    if (messages.length < 2) return;

    const row = document.createElement('div');
    row.className = 'inspire-announcement-titlebar';
    row.setAttribute('role', 'list');
    messages.forEach((message) => {
      const item = document.createElement('span');
      item.setAttribute('role', 'listitem');
      item.textContent = message;
      row.append(item);
    });
    content.replaceChildren(row);
    bar.dataset.inspireLayoutNormalized = 'true';
  };

  const initializeEssentialBars = () => {
    document.querySelectorAll('.essential_annoucement_bar_wrapper').forEach(normalizeEssentialBar);
  };

  const initialize = () => {
    document.querySelectorAll('slideshow-component.announcement-bar').forEach((bar) => {
      if (bar.dataset.adaptiveInitialized === 'true') return;
      bar.dataset.adaptiveInitialized = 'true';
      const refresh = () => update(bar);
      requestAnimationFrame(refresh);
      document.fonts?.ready.then(refresh);
      new ResizeObserver(refresh).observe(bar);
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
  initializeEssentialBars();
  new MutationObserver(initializeEssentialBars).observe(document.documentElement, { childList: true, subtree: true });
})();
